import { ulid as baseUlid, encodeTime, monotonicFactory } from "ulid";

import { isNullish } from "../types/index.ts";

export function generatePRNG(): number {
  const array = new Uint32Array(1);

  crypto.getRandomValues(array);

  const value = array[0];

  if (isNullish(value)) {
    throw new Error("Failed to generate PRNG");
  }

  const MAX_UINT32_PLUS_ONE = 0x1_00_00_00_00;

  return value / MAX_UINT32_PLUS_ONE;
}

const monotonic = monotonicFactory(generatePRNG);

export const ulid = Object.assign(() => monotonic(), {
  encodeTime: (time: number) => encodeTime(time),
  random: (time: number) => baseUlid(time, generatePRNG),
});
